import { render } from "./InnerNavigation.vue?vue&type=template&id=4a407a96"
import script from "./InnerNavigation.vue?vue&type=script&lang=js"
export * from "./InnerNavigation.vue?vue&type=script&lang=js"

import "./InnerNavigation.vue?vue&type=style&index=0&id=4a407a96&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__